
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-martin-warner",
      function () {
        return require("private-next-pages/contact-martin-warner/index.js");
      }
    ]);
  